import {BifrostBackendApi, BifrostBackendNestApi} from "../gateways/BifrostBackendApi.js";
import appConfig from "../appconfig";
import { store } from "../store";

const LoggerProvider = {
	async find({message}) {
		const res = await BifrostBackendApi.get("/logger", {
			params: {
				message
			},
			headers: {
				Authorization: store.getters.jwtToken
			}
		});

		return res.data;
	},

	async logEvent({message, eventName, eventCategory, eventDomain, data}) {
		const traceId = appConfig.clientTraceId();

		return BifrostBackendNestApi.post(`/logger`, { traceId, ...data }, {
			headers: { Authorization: store.getters.jwtToken },
			params: {
				message,
				eventName,
				eventCategory,
				eventDomain
			}
		}).then(response => {
			return response.data;
		});
	}
};

export default Object.freeze(LoggerProvider);
